<template>
  <div class="page container">

        <div class="row mb-4">
            <div class="col-4">
            <div class="col-12 text-right">

               <router-link to="/">
                   <img class="w-70 pull-right" alt="Vue logo" src="../assets/logo.svg">
                </router-link>
            </div>
          </div>
          <div class="col-8">
              <h1> Faça seu pedido! </h1>
          </div>

        </div>
        <div class="row" v-if="open || $route.query.hasOwnProperty('debug')">
          <div class="col">
            <lista-produtos />
          </div>
        </div>
        <div class="row mt-5" v-else>
          <div class="col">
            <div class="alert alert-info text-left">
                <b> Aguarde!</b>
                <p> {{listaInfo.info}} </p>
            </div>
          </div>
        </div>





  </div>
</template>

<script>
// @ is an alias to /src
import ListaProdutos from '@/components/pedido/lista-produtos'

export default {
  
  name: 'Home',
  
  components: {
    ListaProdutos
  },

  created(){
    this.$store.dispatch('getProdutos')
  },

  computed:{
      listaInfo:function(){
        return this.$store.getters.listaInfo
      },

      open:function(){



          if(this.listaInfo.dataInicial ==''){
            return false
          }
          let today = new Date();
          let start = new Date(this.listaInfo.dataInicial+"T"+this.listaInfo.horarioInicial)
          let end = new Date(this.listaInfo.dataFinal+"T"+this.listaInfo.horarioFinal)
          if( today >= start && today <=end){
            return true
          }
          return false
      },

  }

}

</script>
